import { prefetchResources } from '@ds-frontend/resource'

import ServiceReviewsView from './ServiceReviewsView'
import { Loading } from 'common/widgets'


export default prefetchResources({
  endpoint: 'api/v1/feefo/service-reviews',
  namespace: 'serviceReviews',
  reducer: 'paginationList',
  queries: ['offset', 'limit'],
}, {
  defaultParams: { offset: 0, limit: 3 },
  Loader: Loading,
  destroyOnUnmount: true,
  refresh: false,
})(ServiceReviewsView)
